var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71416 0.816895C3.03633 0.816879 3.29751 1.07803 3.29753 1.4002L3.29766 4.04359H7.59184C7.84686 3.12397 8.69001 2.44893 9.69083 2.44893C10.8937 2.44893 11.8688 3.42405 11.8688 4.62692C11.8688 5.8298 10.8937 6.80492 9.69083 6.80492C8.69001 6.80492 7.84686 6.12987 7.59184 5.21026H3.29771L3.29788 8.67232C3.29793 9.63878 4.08142 10.4222 5.04788 10.4222H7.59184C7.84686 9.50262 8.69001 8.82757 9.69083 8.82757C10.8937 8.82757 11.8688 9.80269 11.8688 11.0056C11.8688 12.2084 10.8937 13.1836 9.69083 13.1836C8.69001 13.1836 7.84686 12.5085 7.59184 11.5889H5.04788C3.43711 11.5889 2.1313 10.2831 2.13122 8.67238L2.13102 4.64069C2.13091 4.63612 2.13086 4.63153 2.13086 4.62692C2.13086 4.62234 2.13091 4.61777 2.13102 4.61321L2.13086 1.40026C2.13084 1.07809 2.392 0.81691 2.71416 0.816895ZM9.69083 3.6156C9.13229 3.6156 8.67951 4.06838 8.67951 4.62692C8.67951 5.18546 9.13229 5.63825 9.69083 5.63825C10.2494 5.63825 10.7022 5.18546 10.7022 4.62692C10.7022 4.06838 10.2494 3.6156 9.69083 3.6156ZM9.69083 9.99424C9.13229 9.99424 8.67951 10.447 8.67951 11.0056C8.67951 11.5641 9.13229 12.0169 9.69083 12.0169C10.2494 12.0169 10.7022 11.5641 10.7022 11.0056C10.7022 10.447 10.2494 9.99424 9.69083 9.99424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNested);
export default __webpack_public_path__ + "static/media/nested.9fab1fd5d607c300b44f7705c8ecffea.svg";
export { ForwardRef as ReactComponent };